const apiUrl = process.env.REACT_APP_API_URL;
export const PostAnswerRating = async (id_aula: number, id_answer: number, estat: string, id_user: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/answer/${id_answer}/rating`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ estat, id_user })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
